import React, { useState, useEffect, useCallback } from 'react';
import Modal from '../components/Modal';
import api from '../hooks/api';

const emptyForm = { name: '', city: '', address: '' };

export default function BranchesPage() {
  const [branches, setBranches] = useState([]);
  const [modal, setModal] = useState(null);
  const [editId, setEditId] = useState(null);
  const [form, setForm] = useState(emptyForm);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    setBranches(await api.get('/api/branches'));
  }, []);

  useEffect(() => { load(); }, [load]);

  function openAdd() { setForm(emptyForm); setEditId(null); setError(''); setModal(true); }

  function openEdit(b) {
    setForm({ name: b.name, city: b.city || '', address: b.address || '' });
    setEditId(b.id); setError(''); setModal(true);
  }

  function set(k, v) { setForm(f => ({ ...f, [k]: v })); }

  async function handleSave(e) {
    e.preventDefault(); setError('');
    try {
      if (editId) await api.put('/api/branches/' + editId, form);
      else await api.post('/api/branches', form);
      setModal(null); load();
    } catch (err) { setError(err.message); }
  }

  async function handleDelete(b) {
    if (!window.confirm(`Delete branch "${b.name}"? This will also delete all departments in this branch.`)) return;
    try {
      await api.delete('/api/branches/' + b.id);
      load();
    } catch (err) { alert(err.message); }
  }

  return (
    <div className="page">
      <div className="page-header">
        <h1 className="page-title" style={{ margin: 0 }}>Branches</h1>
        <button className="btn btn-primary" onClick={openAdd}>+ Add Branch</button>
      </div>
      <div className="table-wrap">
        <table className="table">
          <thead>
            <tr><th>Name</th><th>City</th><th>Address</th><th>Departments</th><th>Created</th><th>Actions</th></tr>
          </thead>
          <tbody>
            {branches.map(b => (
              <tr key={b.id}>
                <td style={{ fontWeight: 600 }}>{b.name}</td>
                <td>{b.city || '—'}</td>
                <td>{b.address || '—'}</td>
                <td><span className="count-badge">{b.dept_count}</span></td>
                <td>{b.created_at ? new Date(b.created_at).toLocaleDateString() : '—'}</td>
                <td style={{ whiteSpace: 'nowrap' }}>
                  <button className="btn btn-ghost btn-sm" onClick={() => openEdit(b)}>Edit</button>
                  <button className="btn btn-danger btn-sm" style={{ marginLeft: 6 }} onClick={() => handleDelete(b)}>Delete</button>
                </td>
              </tr>
            ))}
            {branches.length === 0 && <tr><td colSpan={6} className="empty">No branches yet</td></tr>}
          </tbody>
        </table>
      </div>

      {modal && (
        <Modal title={editId ? 'Edit Branch' : 'Add Branch'} onClose={() => setModal(null)}>
          {error && <div className="alert alert-error">{error}</div>}
          <form onSubmit={handleSave}>
            <div className="form-group">
              <label>Name *</label>
              <input value={form.name} onChange={e => set('name', e.target.value)} required autoFocus />
            </div>
            <div className="form-group">
              <label>City</label>
              <input value={form.city} onChange={e => set('city', e.target.value)} />
            </div>
            <div className="form-group">
              <label>Address</label>
              <textarea value={form.address} onChange={e => set('address', e.target.value)} rows={3} />
            </div>
            <div className="form-actions">
              <button type="button" className="btn btn-ghost" onClick={() => setModal(null)}>Cancel</button>
              <button type="submit" className="btn btn-primary">{editId ? 'Save Changes' : 'Add Branch'}</button>
            </div>
          </form>
        </Modal>
      )}
    </div>
  );
}
